<template>
  <div>
    <div class="p-box">
      <div class="p-box__body">
        <template v-if="notAvailableType === 'emptyStore'">
          <GuideToSetUpSite
            :is-more-than-editor="isMoreThanEditor"
          />
        </template>

        <template v-if="notAvailableType === 'emptyFranchisee'">
          <p v-if="isMoreThanEditor">
            フランチャイジー別の分析を見るためには、
            <router-link :to="{ name: 'CompaniesFranchiseeNew', params: { company_uuid: companyUuid }}">
              フランチャイジーをこちらから登録
            </router-link>
            した上で、店舗詳細のオプション設定からフランチャイジーを設定してください。
          </p>
          <p v-else>
            {{ $t('components.notAvailableMessage.franchisee.lessThanOperator.info') }}
          </p>

          <div v-if="isMoreThanEditor" class="c-button c-button--left">
            <router-link
              class="c-button__item c-button__item--primary"
              :to="{ name: 'CompaniesLocationStores', params: { company_uuid: companyUuid }}"
            >
              {{ $t('components.notAvailableMessage.breadcrumbs') }}
            </router-link>
          </div>
        </template>

        <template v-else-if="notAvailableType === 'emptyUserCompany'">
          <p>
            {{ $t('components.notAvailableMessage.userCompany.info') }}
          </p>
          <div v-if="isMoreThanEditor" class="c-button c-button--left">
            <router-link
              class="c-button__item c-button__item--primary"
              :to="{ name: 'CompaniesLocationStores', params: { company_uuid: companyUuid }}"
            >
              {{ $t('components.notAvailableMessage.breadcrumbs') }}
            </router-link>
          </div>
        </template>

        <template v-else-if="notAvailableType === 'emptyArea'">
          <p v-if="isMoreThanEditor">
            立地別の分析を見るためには、
            <router-link :to="{ name: 'CompaniesAreasNew', params: { company_uuid: companyUuid }}">
              立地をこちらから登録
            </router-link>
            した上で、店舗詳細のオプション設定から立地を設定してください。
          </p>
          <p v-else>
            {{ $t('components.notAvailableMessage.area.lessThanOperator.info') }}
          </p>
          <div v-if="isMoreThanEditor" class="c-button c-button--left">
            <router-link
              class="c-button__item c-button__item--primary"
              :to="{ name: 'CompaniesLocationStores', params: { company_uuid: companyUuid }}"
            >
              {{ $t('components.notAvailableMessage.breadcrumbs') }}
            </router-link>
          </div>
        </template>

        <template v-else-if="notAvailableType === 'disableSurvey'">
          <p>
            {{ $t('components.RequireSurveys.title') }}
          </p>
          <p>
            {{ $t('components.RequireSurveys.notice') }}
          </p>
        </template>

        <template v-else-if="notAvailableType === 'disableStorePage'">
          <p>
            {{ $t('components.RequireAccessAnalysis.title') }}
          </p>
          <p>
            {{ $t('components.RequireAccessAnalysis.notice') }}
          </p>
          <div v-if="isMoreThanEditor" class="c-button c-button--left">
            <router-link
              class="c-button__item c-button__item--primary"
              :to="{ name: 'CompaniesVisitorStores', params: {company_uuid: companyUuid} }"
            >
              {{ $t('components.RequireAccessAnalysis.toTheLink') }}
            </router-link>
          </div>
        </template>

        <template v-else-if="notAvailableType === 'emptyCompetitor'">
          <GuideToSetUpCompetitor
            :is-more-than-editor="isMoreThanEditor"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import GuideToSetUpSite from './GuideToSetUpSite'
import GuideToSetUpCompetitor from './GuideToSetUpCompetitor'

export default {
  name: 'NotAvailableMessage',
  components: {
    GuideToSetUpSite,
    GuideToSetUpCompetitor
  },
  props: {
    notAvailableType: {
      type: String,
      required: true,
    },
    companyUuid: {
      type: String,
      required: true,
    },
    isMoreThanEditor: {
      type: Boolean,
      required: false
    }
  },
}
</script>
